import {Dispatch} from "react"
import {messagesService} from "@dv5/api"
import {
    loadParts, loadAllParts, loadDescription, changeDescription, addNewPart, DocumentPart, replacePart, replaceParts, removePart,
    setPartComments, addPartComment, updatePartComment, removePartComment, Comment
} from '@dv5/domain'

interface GetCommentsPayload {
    sourceItemId: string
    comments: Array<Comment>
}

interface PartsUpdateBody {
    documentId: string
    changes: Array<DocumentPart>
}

interface PartUpdateBody {
    documentId: string
    changes: DocumentPart
}

interface DocumentDescriptionUpdateBody {
    documentId: string
    changes: string | null
}

interface CommentUpdateBody {
    documentId: string
    changes: Comment
}

interface GetCommentsUpdateBody {
    documentId: string
    changes: GetCommentsPayload
}

class DocumentMessagesService {
    register(dispatch: Dispatch<any>) {
        messagesService.registerService('documents', {
            processors: {
                'parts': (body: PartsUpdateBody) => {
                    dispatch(loadParts(body))
                },
                'all-parts': (body: PartsUpdateBody) => {
                    dispatch(loadAllParts(body))
                },
                'description': (body: DocumentDescriptionUpdateBody) => {
                    dispatch(loadDescription(body))
                },
                'changed-description': (body: DocumentDescriptionUpdateBody) => {
                    dispatch(changeDescription(body))
                },
                'new-part': (body: PartUpdateBody) => {
                    dispatch(addNewPart(body))
                },
                'changed-part': (body: PartUpdateBody) => {
                    dispatch(replacePart(body))
                },
                'changed-part-positions': (body: PartsUpdateBody) => {
                    dispatch(replaceParts(body))
                },
                'removed-part': (body: PartUpdateBody) => {
                    dispatch(removePart(body))
                },
                'part-comments': (body: GetCommentsUpdateBody) => {
                    const {sourceItemId, comments} = body.changes
                    dispatch(setPartComments({sourceItemId, comments, documentId: body.documentId}))
                },
                'new-comment': (body: CommentUpdateBody) => {
                    dispatch(addPartComment({sourceItemId: body.changes.sourceItemId, comment: body.changes, documentId: body.documentId}))
                },
                'edited-part-comment': (body: CommentUpdateBody) => {
                    const comment = body.changes
                    dispatch(updatePartComment({sourceItemId: comment.sourceItemId, comment}))
                },
                'removed-part-comment': (body: CommentUpdateBody) => {
                    const {sourceItemId, id} = body.changes
                    dispatch(removePartComment({sourceItemId, commentId: id, documentId: body.documentId}))
                }
            }
        })
    }
}

export const documentMessagesService = new DocumentMessagesService()
